<div class="p-10 w-full">
  <div class="flex flex-col justify-center items-center gap-8">
    <span i18n>Something has gone wrong!</span>
    <div class="flex flex-row justify-center items-center gap-4">
      @if (refresh || retry) {
        <button type="button" (click)="triggerRetry()" [disabled]="retryInProgress() || resetInProgress()" matButton="outlined">
          <span class="flex flex-row items-center gap-4">
            <span i18n>Retry</span>
            @if (retryInProgress()) {
              <mat-spinner [diameter]="15"></mat-spinner>
            }
          </span>
        </button>
      }
      @if (reset) {
        <button type="button" (click)="triggerReset()" [disabled]="resetInProgress() || retryInProgress()" matButton="outlined">
          <span class="flex flex-row items-center gap-4">
            <span i18n>Reset</span>
            @if (resetInProgress()) {
              <mat-spinner [diameter]="15"></mat-spinner>
            }
          </span>
        </button>
      }
    </div>
    @if (isNotRelease) {
      <span class="text-red-700">{{errorMessage()}}</span>
    }
  </div>
</div>
